import cls from 'clsx';
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withRouter } from 'react-router-dom';
import { useStyles } from './styles';
import { Link as RouterLink } from 'react-router-dom';
import { ClassNameMap } from '@material-ui/styles';

const SidebarListItem = (props: any) => {
   const { text, route, nested, onClick } = props;
   const classes: ClassNameMap = useStyles();
   const [isActiveItem, setActiveItem] = useState(props.location.pathname === route);

   React.useEffect(() => {
      setActiveItem(route === props.location.pathname);
   }, [props.location.pathname, route]);

   const className = cls({
      [classes.sidebarNestedItem]: nested === true,
      [classes.sidebarListItem]: text,
   });

   // const coloredTextClass = cls({
   //    [classes.sidebarActiveColor]: isActiveItem === true,
   // });

   return (
      <ListItem
         className={isActiveItem && !nested ? classes.sidebarListItemActive : className}
         component={RouterLink}
         to={route}
         onClick={onClick}
         button
      >
         {props.icon && (
            <ListItemIcon className={isActiveItem ? classes.sidebarListItemIcon : classes.sidebarIcon}>
               <span className={props.icon}></span>
            </ListItemIcon>
         )}
         <ListItemText
            className={
               isActiveItem && nested ? classes.childListItems : isActiveItem ? classes.sidebarActiveColor : 'nothing'
            }
            primary={text}
         />
      </ListItem>
   );
};

export default withRouter(SidebarListItem);
